module.exports = __webpack_public_path__ + "static/media/blxstLaFunction.295a03a4.png";